import { Store } from '../stores/Store'

import type { StoreOptions, TypedSpecific } from '../types'

/**
 * 创建状态中心
 * @param specific ADT 协议
 * @param options 配置
 */
export function createStore<T extends TypedSpecific>(
  specific: T,
  options: StoreOptions = {}
): Store<T> {
  return Store.createStore(specific, options)
}
